<script setup lang="ts">
import type { PropType } from 'vue'
import type { AdminConfiguratorTemplateType } from '@/entities/Cabinet'
import { useConfiguratorTemplateUse } from './../model/api'
import { useRoute } from 'vue-router'
import { useConfirm, useNotification } from '@/shared/ui'
import { useTranslate } from '@/shared/lib'

const props = defineProps({
  template: {
    type: Object as PropType<AdminConfiguratorTemplateType>,
    required: true,
  },
})

const route = useRoute()
const { show } = useConfirm()
const { addError } = useNotification()
const { trs } = useTranslate()

const { use } = useConfiguratorTemplateUse(Number(route.params.object_id))

/**
 * Обработка использования выбранного шаблона
 */
const clickHandler = () => {
  if (props.template.template.length) {
    show({
      confirmFunc: () => use({ id: props.template.id }),
    })
  } else {
    addError(trs('itf.templates_empty'))
  }
}
</script>

<template>
  <span @click="clickHandler">
    <slot />
  </span>
</template>
